import "./Reception.css";
import { Link } from "react-router-dom";

import sara from "./assets/receptionist.jpeg";
import girlImg from "./assets/registrationgirl2.png";

// room images
import classroomImg from "./assets/classroom.png";
import doubtImg from "./assets/doubtsteacher.png";
import aiImg from "./assets/dashboard.jpeg";
import labImg from "./assets/projecterroom.jpeg";

// main course images
import webDevImg from "./assets/webdevelopment.png";
import pythonImg from "./assets/aiml.png";
import dataAnalyticsImg from "./assets/dataanylatics.png";
import dataScienceImg from "./assets/datascience.png";

// extra courses
import agenticai from "./assets/agenticai.png";
import aiengineering from "./assets/aiengineering.png";
import computervision from "./assets/computervision.png";
import pythondsa from "./assets/pythondsa.png";

export default function Reception() {
  return (
    <div className="reception-container">

      {/* LEFT SIDE */}
      <div className="reception-left">

        <div className="sara-bubble">
          👋 Hi there! <br />
          I’m <b>Sara</b>, your guide. <br />
          How can I help you today?
        </div>

        <img src={sara} alt="Receptionist" className="sara-img" />
      </div>

      {/* RIGHT SIDE */}
      <div className="reception-right">

        {/* COURSES */}
        <div className="section">
          <h2>Courses</h2>
          <div className="image-row">

            <Link to="/web-development">
              <img src={webDevImg} alt="Web Development" />
            </Link>

            <Link to="/ai-ml">
              <img src={pythonImg} alt="AI ML" />
            </Link>

            <Link to="/data-analytics">
              <img src={dataAnalyticsImg} alt="Data Analytics" />
            </Link>

            <Link to="/data-science">
              <img src={dataScienceImg} alt="Data Science" />
            </Link>

          </div>
        </div>

        {/* EXTRA COURSES */}
        <div className="section">
          <div className="image-row">

            <Link to="/agentic-ai">
              <img src={agenticai} alt="Agentic AI" />
            </Link>

            <Link to="/computer-vision">
              <img src={computervision} alt="Computer Vision" />
            </Link>

            <Link to="/python-dsa">
              <img src={pythondsa} alt="Python DSA" />
            </Link>

            <Link to="/ai-engineering">
              <img src={aiengineering} alt="AI Engineering" />
            </Link>

          </div>
        </div>

        {/* ROOMS */}
        <div className="section">
          <h2>Select Your Room</h2>
          <div className="image-row">

            <Link to="/tutor-room">
              <img src={classroomImg} alt="Tutor Room" />
            </Link>

            <Link to="/doubt-room">
              <img src={doubtImg} alt="Doubt Room" />
            </Link>

            <Link to="/dashboard">
              <img src={aiImg} alt="AI Room" />
            </Link>

            <Link to="/projector-room">
              <img src={labImg} alt="Projector Room" />
            </Link>

          </div>
        </div>

        {/* BOTTOM CTA */}
        <div className="bottom-cta-area">

          <div className="thought-card">
            🎁 <b>First lesson free!</b><br />
            ⭐ Every expert was once a beginner.<br />
            Start today!
          </div>

          <div className="reception-register-card">
            <h2>Get Started with BCI 🎓</h2>
            <p>Join thousands of learners and start building your skills today.</p>

            <Link to="/register">
              <button className="reception-register-btn">
                Register Now
              </button>
            </Link>
          </div>

          <img src={girlImg} className="guide-girl" alt="Guide Girl" />

        </div>

      </div>
    </div>
  );
}
